import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["icon"];
import React from 'react';
import Logistics from './Logistics';
import General from './General';
import ShopeePayment from './ShopeePayment';
import AccountFraud from './AccountFraud';
import ReturnRefund from './ReturnRefund';
import Marketing from './Marketing';
import BD from './BD';
import ContentLegal from './ContentLegal';
import ShopeePay from './ShopeePay';
import SPayLater from './SPayLater';
import DigitalProduct from './DigitalProduct';
import Others from './Others';
import FoodDelivery from './FoodDelivery';
import ShopeeExpress from './ShopeeExpress';
export var CategoryIconEnum;
(function (CategoryIconEnum) {
  CategoryIconEnum["Logistics"] = "logistics";
  CategoryIconEnum["ShopeePayment"] = "shopee_payment";
  CategoryIconEnum["AccountFraud"] = "account_fraud";
  CategoryIconEnum["ReturnRefund"] = "return_refund";
  CategoryIconEnum["Marketing"] = "marketing";
  CategoryIconEnum["BD"] = "bd";
  CategoryIconEnum["General"] = "general";
  CategoryIconEnum["ContentLegal"] = "content_legal";
  CategoryIconEnum["ShopeePay"] = "shopeepay";
  CategoryIconEnum["SPayLater"] = "spaylater";
  CategoryIconEnum["DigitalProduct"] = "digital_product";
  CategoryIconEnum["Others"] = "others";
  CategoryIconEnum["FoodDelivery"] = "food_delivery";
  CategoryIconEnum["ShopeeExpress"] = "img_shopee_express";
})(CategoryIconEnum || (CategoryIconEnum = {}));
var CategoryIcon = function CategoryIcon(props) {
  var icon = props.icon,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (icon === CategoryIconEnum.Logistics) {
    return /*#__PURE__*/React.createElement(Logistics, otherProps);
  } else if (icon === CategoryIconEnum.ShopeePayment) {
    return /*#__PURE__*/React.createElement(ShopeePayment, otherProps);
  } else if (icon === CategoryIconEnum.AccountFraud) {
    return /*#__PURE__*/React.createElement(AccountFraud, otherProps);
  } else if (icon === CategoryIconEnum.ReturnRefund) {
    return /*#__PURE__*/React.createElement(ReturnRefund, otherProps);
  } else if (icon === CategoryIconEnum.Marketing) {
    return /*#__PURE__*/React.createElement(Marketing, otherProps);
  } else if (icon === CategoryIconEnum.BD) {
    return /*#__PURE__*/React.createElement(BD, otherProps);
  } else if (icon === CategoryIconEnum.ContentLegal) {
    return /*#__PURE__*/React.createElement(ContentLegal, otherProps);
  } else if (icon === CategoryIconEnum.ShopeePay) {
    return /*#__PURE__*/React.createElement(ShopeePay, otherProps);
  } else if (icon === CategoryIconEnum.SPayLater) {
    return /*#__PURE__*/React.createElement(SPayLater, otherProps);
  } else if (icon === CategoryIconEnum.DigitalProduct) {
    return /*#__PURE__*/React.createElement(DigitalProduct, otherProps);
  } else if (icon === CategoryIconEnum.Others) {
    return /*#__PURE__*/React.createElement(Others, otherProps);
  } else if (icon === CategoryIconEnum.FoodDelivery) {
    return /*#__PURE__*/React.createElement(FoodDelivery, otherProps);
  } else if (icon === CategoryIconEnum.ShopeeExpress) {
    return /*#__PURE__*/React.createElement(ShopeeExpress, otherProps);
  } else {
    return /*#__PURE__*/React.createElement(General, otherProps);
  }
};
export default CategoryIcon;